var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-category"},[_c('error',{attrs:{"errors":_vm.categoryError}}),_c('category-form',{attrs:{"action":"edit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }